var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "featured-carousel-wrapper" },
    [_c("product-hero-carousel", { attrs: { items: _vm.carouselItems } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }